var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ProfilesIndicator" }, [
    _c(
      "ul",
      [
        _vm.perf
          ? [
              _c("li", [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("profile.indicators.last_alert"))),
                ]),
                _c("br"),
                _vm._v(" "),
                _vm.perf.last_alert && _vm.perf.last_alert.type
                  ? _c("span", [
                      _c("i", { class: _vm.perf.last_alert.type }),
                      _vm._v(" "),
                      _vm.perf.last_alert.dati
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.perf.last_alert.dati.name
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.dateFormatShort(_vm.perf.last_alert.date.date)
                          ),
                        },
                      }),
                      _vm._v("."),
                      _c("br"),
                      _vm._v(" "),
                      _vm.perf.last_alert.resolved_by
                        ? _c("span", { staticClass: "text-muted" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("profile.indicators.resolved_by")
                                ) +
                                "\n            "
                            ),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.perf.last_alert.resolved_by
                                ),
                              },
                            }),
                          ])
                        : _c("em", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$t("profile.indicators.not_resolved"))
                            ),
                          ]),
                    ])
                  : _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("profile.indicators.no_alert"))),
                    ]),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("label", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("profile.indicators.last_days_alerts")) +
                      "\n          "
                  ),
                  _c("span", { staticClass: "text-mono" }, [
                    _vm._v("(" + _vm._s(_vm.totalAlerts) + ")"),
                  ]),
                ]),
                _c("br"),
                _vm._v(" "),
                !!_vm.totalAlerts
                  ? _c(
                      "span",
                      _vm._l(_vm.lastDaysAlertFiltered, function (v, k, i) {
                        return _c("div", { key: k, staticClass: "mr-1" }, [
                          _c("i", { staticClass: "fa-lg fa-fw", class: k }),
                          _vm._v(" " + _vm._s(_vm.getAlertName(k)) + " : "),
                          _c("span", {
                            staticClass: "text-mono ml-1",
                            domProps: { textContent: _vm._s(v) },
                          }),
                        ])
                      }),
                      0
                    )
                  : _c("span", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("profile.indicators.no_alert"))),
                    ]),
              ]),
              _vm._v(" "),
              _vm.perf.updated_by && !!_vm.perf.updated_at
                ? _c("li", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("profile.indicators.last_update"))),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.perf.updated_by) },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.dateFormatShort(_vm.perf.updated_at.date)
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.perf.created_by && !!_vm.perf.created_at
                ? _c("li", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("profile.indicators.creation"))),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.perf.created_by) },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.dateFormatShort(_vm.perf.created_at.date)
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.datisLicences
          ? _c("li", [
              _c("label", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("profile.indicators.licences")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-mono" }, [
                  _vm._v("(" + _vm._s(_vm.nbDatis) + ")"),
                ]),
              ]),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: ".25em" },
                },
                _vm._l(["45", "43", "35", "58", "57"], function (id) {
                  return _vm.datisLicences[id] > 0
                    ? _c("div", { key: id }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.renderLicence(id)),
                          },
                        }),
                        _vm._v(" :\n          "),
                        _c("span", { staticClass: "text-mono" }, [
                          _vm._v(_vm._s(_vm.datisLicences[id])),
                        ]),
                      ])
                    : _vm._e()
                }),
                0
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }